var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPathway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pathway",
    transform: "translate(1686 -6946.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "straight_FILL1_wght400_GRAD0_opsz48",
    d: "M18.1,18V7.9L16.6,9.4l-.7-.7L18.6,6l2.7,2.7-.7.7L19.1,7.9V18Z",
    transform: "translate(-1668 6935.7) rotate(90)",
    fill: "#3281ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "straight_FILL1_wght400_GRAD0_opsz48-2",
    "data-name": "straight_FILL1_wght400_GRAD0_opsz48",
    d: "M18.1,15V7.9L16.6,9.4l-.7-.7L18.6,6l2.7,2.7-.7.7L19.1,7.9V15Z",
    transform: "translate(-1671 6930.3) rotate(90)",
    fill: "#3281ac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathway);
export default __webpack_public_path__ + "static/media/Pathway.05c254dcd890c11f378770c8230e35b0.svg";
export { ForwardRef as ReactComponent };